import {BannerContainerDefaultBox} from "./banner-container.default.box";

export const BannerContainerBox = BannerContainerDefaultBox;